/**
 * Created by jdickman on 3/13/17.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'login/:advertiserId',
        component: LoginComponent
      }
    ])
  ],
  exports: [RouterModule]
})
export class LoginRoutingModule {}
